var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.title)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.test)?_c('v-card-text',[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }